/**
 * 客服图标
 */
const CustomerServiceIcon = ({ width = 32, height = 32, color = '#000000' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.4167 22.6406V14.3073C26.4167 8.55433 21.753 3.89062 16 3.89062V3.89062C10.2471 3.89062 5.58337 8.55433 5.58337 14.3073V22.6406"
        stroke="black"
        strokeWidth="2.66667"
      />
      <path
        d="M26.4167 15.3491V24.1992C26.4167 26.0402 24.9243 27.5326 23.0833 27.5326H16"
        stroke="black"
        strokeWidth="2.66667"
      />
      <path
        d="M5.58337 16.3906H9.30749L11 18.2152V22.6406H5.58337V16.3906Z"
        stroke="black"
        strokeWidth="2.66667"
      />
      <path
        d="M26.4166 16.3906H22.6925L21 18.2152V22.6406H26.4166V16.3906Z"
        stroke="black"
        strokeWidth="2.66667"
      />
      <path
        d="M17.6666 26.6665H13.5V28.3332H17.6666V26.6665Z"
        fill="#BBBBBD"
        stroke={color}
        strokeWidth="2.66667"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CustomerServiceIcon
